<template>
    <section class="topper topper-tall relative flex items-center px-4 bg-primary-700 py-20%">
        
        <template v-if="background_image">
            <Burn direction="left" start="5%" end="70%"></Burn>
            <Burn direction="top" start="0%" end="15%"></Burn>
            <div class="hero-image absolute overflow-hidden bg-primary-800 left-0 top-0 w-full h-full">
                <BackgroundImage :src="background_image.src" opacity="0.5" :alt="background_image.alt" parallax="0.15"></BackgroundImage>
            </div>
        </template>

        <div class="interior relative z-30 mx-auto w-full">
            <div class="max-w-4xl mx-auto">
                <SmoothLoader class="text-container">

                    <h1 :class="background_image ? 'text-white' : 'text-gray-800'" class="headline  w-full font-black font-headline tracking-wide leading-tight text-5xl vt:text-7xl ht:text-8xl text-shadow-1" v-html="headline"></h1>
                    <div v-if="options.blurb || options.topper_button" class="max-w-md mt-4">
                        <p v-if="options.blurb" class="blurb font-body text-lg" :class="background_image ? 'text-white' : 'text-gray-800'" v-html="options.blurb"></p>
                        <div v-if="options.topper_button" class="mt-4 max-w-sm">
                            <Button variant="button-1" :url="options.topper_button.url" :label="options.topper_button.label"></Button>
                        </div>

                    </div>

                </SmoothLoader>
            </div>
        </div>

    </section>
</template>

<script>

// https://vueuse.org/core/useelementvisibility/#demo
import { ref, computed } from 'vue';

export default {
    
    props: ['data'],

    setup(props) {

        return {
            ...props.data
        }

    }

}
</script>